import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@store/store'

const getState = (state: RootState) => state.common

export const getToasts = createSelector(getState, (state) => state.toasts)
export const previousPath = createSelector(getState, (state) => state.redirect)
export const getContentImgs = createSelector(getState, (state) => state.imgs)
export const helper = createSelector(getState, (state) => state.helper)
